// extracted by mini-css-extract-plugin
export default {"features":"Features_features__Psv8T","featureCard":"Features_featureCard__UPjDO"};